import { Outlet } from "react-router-dom";

import Loading from "@/components/molecules/Loading";
import { useNavigationContext } from "@/context/NavigationContext";

const IndexRoute = () => {
  const { isNavigating } = useNavigationContext();

  return (
    <>
      <Outlet />
      {isNavigating && <Loading container="#drawer-content" inContainer />}
    </>
  );
};

export default IndexRoute;
